import { clomp } from 'clomp';

export const Form = clomp.form`
  flex
  flex-col
  items-center
  relative
  w-full
`;
